import { useAppSelector } from '@/store/hooks';
import { selectUserRole } from '@/store/slices/auth.selectors';
import type { Role } from '@/constants/roles.constants';

/**
 * The backend only exposes a single role slug per user (no per-user permission
 * list), so authorization here is role-based rather than permission-based.
 */
export function usePermission() {
  const role = useAppSelector(selectUserRole);

  const hasRole = (checkRole: Role): boolean => role?.slug === checkRole;
  const hasAnyRole = (allowedRoles: Role[]): boolean =>
    allowedRoles.some((checkRole) => role?.slug === checkRole);

  return { role, hasRole, hasAnyRole };
}
